import { callApiWithAuthorization } from "../CallApi";

export async function getInstances(projectId) {
    const request = await callApiWithAuthorization(`/api/v0/project/${projectId}/instances`);
    const response = await request.json();
    return response;
}

export async function createInstance(subscriptionId, projectId, properties) {
    const request = await callApiWithAuthorization('/api/v0/project/' + projectId + '/instance', {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            subscriptionId,
            properties
        })
    })
    const response = await request.json();
    return response;
}

export async function updateInstanceAfterPublishData(instanceId, userId) {
    const request = await callApiWithAuthorization('/api/v0/instance/' + instanceId + '/update-published-data', {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            userId
        })
    });
    const response = await request.json();
    return response;
}